import React from "react";
import { FaSpinner } from "react-icons/fa";
import styles from "./styles.module.sass";

const LoadingSpinner = ({
  width = 200,
  height = 200,
  fontSize = 52,
  componentLoader = false,
  props
}) => (
    <div className={componentLoader ? styles.component_loader : styles.loader}>
      <div className={componentLoader ? styles.component_loader_box : styles.loader_box}>
        <div className={componentLoader ? styles.component_loader_box_img :styles.loader_box_img}>
          <FaSpinner
              width={width}
              height={height}
              fontSize={fontSize}
          />
        </div>
      </div>
    </div>
);

export default LoadingSpinner;
